export function Lock(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="20"
        height="24"
        viewBox="0 0 20 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0.900002C6.57583 0.900002 3.8 3.67584 3.8 7.1V9.1H3C1.34315 9.1 0 10.4431 0 12.1V20.1C0 21.7569 1.34315 23.1 3 23.1H17C18.6569 23.1 20 21.7569 20 20.1V12.1C20 10.4431 18.6569 9.1 17 9.1H16.2V7.1C16.2 3.67584 13.4242 0.900002 10 0.900002ZM13.8 9.1V7.1C13.8 5.00132 12.0987 3.3 10 3.3C7.90132 3.3 6.2 5.00132 6.2 7.1V9.1H13.8Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
